import script from "./UpdateData.vue?vue&type=script&setup=true&lang=js"
export * from "./UpdateData.vue?vue&type=script&setup=true&lang=js"

import "./UpdateData.vue?vue&type=style&index=0&id=405e1bce&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-405e1bce"]])

export default __exports__